import { SubscriptionEntitlements } from "src/app/subscription/subscriptionUtils";
import { SubscriptionUsageModalMode } from "src/app/subscription/modals/SubscriptionUsageModal/SubscriptionUsageModal";

import { subscriptionTypes } from "./subscriptionTypes";

export interface SubscriptionPlan {
  name: string;
  isCustomerStripe: boolean;
  isPaymentMethodSet: boolean;
}

interface SubscriptionBillingInfo {
  billingInfoExists: boolean;
  billingPortalLink: string | null;
  taxRatePercent: number | null;
}

export interface SubscriptionReducerState {
  subscriptionUsageModalMode: SubscriptionUsageModalMode | null;
  manageSubscriptionModalVisible: boolean;
  planUpgradeNeededModalContext: SubscriptionEntitlements | null;
  subscriptionContactModalDisplayMode: null | "default" | "demandPermission";
  subscriptionPlan: SubscriptionPlan | null;
  unlockAddonsModalVisibility: boolean;
  addBillingInfoModalVisibility: boolean;
  billingInfo: SubscriptionBillingInfo | null;
  entitlements: {
    [key in SubscriptionEntitlements]?: boolean;
  };
  entitlementsLoading: {
    [key in SubscriptionEntitlements]?: boolean;
  };
}

const initialState: SubscriptionReducerState = {
  subscriptionUsageModalMode: null,
  manageSubscriptionModalVisible: false,
  planUpgradeNeededModalContext: null,
  subscriptionContactModalDisplayMode: null,
  subscriptionPlan: null,
  unlockAddonsModalVisibility: false,
  addBillingInfoModalVisibility: false,
  billingInfo: null,
  entitlements: {},
  entitlementsLoading: {},
};

interface SubscriptionReducerAction {
  type: keyof typeof subscriptionTypes;
  payload: any;
}

function subscriptionReducer(
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state = initialState,
  action: SubscriptionReducerAction,
) {
  switch (action.type) {
    case "SET_SUBSCRIPTION_MODAL_MODE":
      return {
        ...state,
        subscriptionUsageModalMode: action.payload.subscriptionUsageModalMode,
      };

    case "SET_MANAGE_SUBSCRIPTION_MODAL_VISIBILITY":
      return {
        ...state,
        manageSubscriptionModalVisible:
          action.payload.manageSubscriptionModalVisible,
      };

    case "SET_PLAN_UPGRADE_NEEDED_MODAL_CONTEXT":
      return {
        ...state,
        planUpgradeNeededModalContext:
          action.payload.planUpgradeNeededModalContext,
      };

    case "SET_SUBSCRIPTION_CONTACT_MODAL_DISPLAY_MODE":
      return {
        ...state,
        subscriptionContactModalDisplayMode:
          action.payload.subscriptionContactModalDisplayMode,
      };

    case "SET_UNLOCK_ADDONS_MODAL_VISIBILITY":
      return {
        ...state,
        unlockAddonsModalVisibility: action.payload.unlockAddonsModalVisibility,
      };

    case "SET_ADD_BILLING_INFO_MODAL_VISIBILITY":
      return {
        ...state,
        addBillingInfoModalVisibility:
          action.payload.addBillingInfoModalVisibility,
      };

    case "GET_SUBSCRIPTION_BILLING_INFO_SUCCESS":
      return {
        ...state,
        billingInfo: action.payload.data.content,
      };

    case "GET_SUBSCRIPTION_PLAN_SUCCESS":
      return {
        ...state,
        subscriptionPlan: action.payload.data.content,
      };

    case "GET_SUBSCRIPTION_ENTITLEMENT":
      return {
        ...state,
        entitlementsLoading: {
          ...state.entitlementsLoading,
          [action.payload.feature]: true,
        },
      };

    case "GET_SUBSCRIPTION_ENTITLEMENT_SUCCESS": {
      const { content } = action.payload.data;
      const key = Object.keys(content)[0];
      const value = content[key].hasAccess;

      return {
        ...state,
        entitlements: {
          ...state.entitlements,
          [key]: value,
        },
        entitlementsLoading: {
          ...state.entitlementsLoading,
          [key]: false,
        },
      };
    }

    default:
      return state;
  }
}

export default subscriptionReducer;
